// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2638":"e058a96d","5503":"cf30f18c","8442":"defc669b","9095":"defc669b","9780":"defc669b"}[chunkId] + ".chunk.css";
};